import { render, staticRenderFns } from "./CollectionConfig.vue?vue&type=template&id=20ab8e44&scoped=true"
import script from "./CollectionConfig.vue?vue&type=script&lang=js"
export * from "./CollectionConfig.vue?vue&type=script&lang=js"
import style0 from "./CollectionConfig.vue?vue&type=style&index=0&id=20ab8e44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ab8e44",
  null
  
)

export default component.exports